module.exports = __webpack_public_path__ + "static/media/Surgeon.02795298.jpg";